<template lang="html">
    <header>
        <nav :class="{sticky: this.$store.getters.sticky}">
            <div class="row">
                <img src="../../assets/resources/img/ihd-logo-white.png" alt="ihd logo" class="logo">
                <!-- <a href="#"> -->
                <img src="../../assets/resources/img/ihd-logo.png" alt="ihd logo" class="logo-black">
                <!-- </a> -->
                <ul v-show="windowWidth || stack_nav" class="main-nav">
                    <li><a href="#features" v-smooth-scroll="{duration: 800}">项目</a></li>
                    <li><a href="#skills" v-smooth-scroll="{duration: 800}">技能</a></li>
                    <li><a href="#schedule" v-smooth-scroll="{duration: 800}">日程</a></li>
                    <li><a href="#companies" v-smooth-scroll="{duration: 800}">合作公司</a></li>
                    <li><a href="#contact-form" v-smooth-scroll="{duration: 800}">加入</a></li>
                </ul>
                <a class="mobile-nav-icon" @click.prevent="stack_nav = !stack_nav">
                    <i :class="{'ion-navicon-round': !stack_nav, 'ion-close-round': stack_nav}"></i>
                </a>
            </div>
        </nav>
        <div class="hero-text-box">
            <h1>
                <vue-typer text='International Horizon Developer' caret-animation='smooth' type-delay='160' :repeat='0'></vue-typer><br>
            </h1>
            <h1 class="fixed-line-height">
                <vue-typer text='为你提供最好的职场技能培训' caret-animation='smooth' type-delay='160' :repeat='0' pre-type-delay='5500'></vue-typer>
            </h1>

            <br>
            <a class="btn btn-full" href="#contact-form" v-smooth-scroll="{duration: 800}">Join us</a>
            <a
                class="btn btn-ghost"
                href="https://firebasestorage.googleapis.com/v0/b/ihd-official-website.appspot.com/o/pdf%2Fihdintro.pdf?alt=media&token=b25185c8-dcae-47bf-a4c3-274457968538"
                download="https://firebasestorage.googleapis.com/v0/b/ihd-official-website.appspot.com/o/pdf%2Fihdintro.pdf?alt=media&token=b25185c8-dcae-47bf-a4c3-274457968538"
                >Show me more</a>
        </div>
    </header>
</template>

<script>
// import vue typer component
import { VueTyper } from 'vue-typer'



// import firebase storage
import { storage } from '../../store/firebase';
let pdfRef = storage.ref('pdf/ihdintro.pdf');



let medium_screen = 767;

export default {
    data() {
        return {
            stack_nav: false
        }
    },
    computed: {
        windowWidth() {
            console.log(document.documentElement.clientWidth);
            return document.documentElement.clientWidth > medium_screen;
        }
    },
    components: {
        VueTyper
    }
}
</script>

<style lang="scss">
@import "../../assets/resources/css/partials/variables";

header {
    background-image: -webkit-linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(../../assets/resources/img/background-img.jpg);
    background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(../../assets/resources/img/background-img.jpg);
    background-size: cover;
    background-position: center;
    height: 100vh;
    background-attachment: fixed;
}

.hero-text-box {
    position: absolute;
    width: 1140px;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);

    @media only screen and (max-width: 1200px) {
        width: 100%;
        padding: 0 2%;
    }

    @media only screen and (max-width: $medium-screen) {
        width: 100%;
        margin: 0 0 4% 0;
    }

}

.logo {
    height: 100px;
    width: auto;
    float: left;
    margin-top: 20px;
}

.logo-black {
    display: none;
    height: 50px;
    width: auto;
    float: left;
    margin: 5px 0;
}

/* Main navi */
.main-nav {
    float: right;
    list-style: none;
    margin-top: 55px;
    z-index: 9999;

    @media only screen and (max-width: $medium-screen) {
        float: left;
        margin-top: 30px;
        margin-left: 25px;
    }

    li {
        display: inline-block;
        margin-left: 40px;

        @media only screen and (max-width: $medium-screen) {
            display: block;
        }

        a {
            &:link, &:visited {
                padding: 8px 0;
                color: #fff;
                text-decoration: none;
                text-transform: uppercase;
                font-size: 90%;
                border-bottom: 2px solid transparent;
                -webkit-transition: border-bottom 0.2s;
                transition: border-bottom 0.2s;

                @media only screen and (max-width: $medium-screen) {
                    display: block;
                    border: 0;
                    padding: 10px 0;
                    font-size: 100%;
                }

            }

            &:hover, &:active {
                border-bottom: 2px solid $theme-color;
            }
        }
    }
}

/* Mobile navi */
.mobile-nav-icon {
    float: right;
    margin-top: 30px;
    cursor: pointer;
    display: none;

    @media only screen and (max-width: $medium-screen) {
        display: inline-block;
    }
}

.mobile-nav-icon i {
    font-size: 200%;
    color: #fff;
}

/* Sticky navi */
.sticky {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.98);
    box-shadow: 0 2px 2px #efefef;
    z-index: 9999;
}

.sticky .main-nav {
    margin-top: 18px;
    @media only screen and (max-width: $medium-screen) {
        margin-top: 10px;
    }
}

@media only screen and (max-width: $medium-screen) {
    .sticky .main-nav li a:link,
    .sticky .main-nav li a:visited { padding: 5px 0; }
    .sticky .mobile-nav-icon { margin-top: 10px; }
    .sticky .mobile-nav-icon i { color: #555; }
}


.sticky .main-nav li a:link,
.sticky .main-nav li a:visited {
    padding: 16px 0;
    color: #555;
}

.sticky .logo { display: none; }
.sticky .logo-black { display: block; }


// custmize the typer's color

.vue-typer {
    .custom.char {
        color: #fff;
    }
}

.fixed-line-height {
    height: 2.4rem;
}
</style>



// WEBPACK FOOTER //
// Header.vue?7a61c814